import Share from './Share';
import ShareKakaoStorySimpleUrlLink from './ShareKakaoStorySimpleUrlLink';
import namespacer from 'js-namespacer';

(function(){
  namespacer( window, 'nc.uikit' );
  window.nc.uikit = {
    ShareV2: Share,
    ShareKakaoStorySimpleUrlLink: ShareKakaoStorySimpleUrlLink
  }
})();
